import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Custom hook to manage keyboard shortcuts and modal visibility
const useKeyboardShortcuts = () => {
  const navigate = useNavigate();
  const [visibleModals, setVisibleModals] = useState({
    ledgerModal: false,
    itemModal: false,
  });
  // Define keyMap for shortcuts
  const keyMap = {
    NAVIGATE_TO_LEDGER: 'alt+L', // Navigate to Ledger List
    NAVIGATE_TO_DASHBOARD: 'alt+D', // Navigate to Dashboard
    NAVIGATE_TO_REPORTS: 'alt+r', // Navigate to Reports
    NAVIGATE_TO_ITEM_LIST: 'alt+I', // Navigate to Reports
    NAVIGATE_TO_SALES_BILL_LIST: 'alt+M', // Navigate to Reports
    NAVIGATE_TO_SALES: 'alt+N', // Navigate to Reports
    NAVIGATE_TO_PURCHASE: 'alt+P', // Navigate to Reports
    NAVIGATE_TO_PAYMENT: 'alt+p', // Navigate to Reports
    NAVIGATE_TO_JOURNAL: 'alt+J', // Navigate to Reports
    NAVIGATE_TO_RECEIPT: 'alt+R', // Navigate to Reports
    OPEN_LEDGER_MODAL: 'alt+l',
    OPEN_ITEM_MODAL: 'alt+i',
  };

  // Define the handlers for the shortcuts
  const handlers = {
    NAVIGATE_TO_LEDGER: () => {
      navigate('/ledger/list/'); // Navigate to Ledger List
    },
    NAVIGATE_TO_DASHBOARD: () => {
      navigate('/dashboard/'); // Navigate to Dashboard
    },
    NAVIGATE_TO_REPORTS: () => {
      navigate('/reports/'); // Navigate to Reports
    },
    NAVIGATE_TO_ITEM_LIST: () => {
      navigate('/inventory/item/list/'); // Navigate to Reports
    },
    NAVIGATE_TO_SALES_BILL_LIST: () => {
      navigate('/inventory/item/list/'); // Navigate to Reports
    },
    NAVIGATE_TO_SALES: () => {
      navigate('/sales/list/'); // Navigate to Reports
    },
    NAVIGATE_TO_PURCHASE: () => {
      navigate('/purchase/create/'); // Navigate to Reports
    },
    NAVIGATE_TO_PAYMENT: () => {
      navigate('/payment/voucher/create/'); // Navigate to Reports
    },
    NAVIGATE_TO_JOURNAL: () => {
      navigate('/journal/voucher/create/'); // Navigate to Reports
    },
    NAVIGATE_TO_RECEIPT: () => {
      navigate('/receipt/voucher/create/'); // Navigate to Reports
    },
    OPEN_LEDGER_MODAL: () => {
      setVisibleModals((prev) => ({ ...prev, ledgerModal: true }));
    },
    OPEN_ITEM_MODAL: () => {
      setVisibleModals((prev) => ({ ...prev, itemModal: true }));
    },
  };

  const closeModal = (modalKey) => {
    setVisibleModals((prev) => ({ ...prev, [modalKey]: false }));
  };

  return {
    keyMap,
    handlers,
    visibleModals,
    closeModal,
  };
};

export default useKeyboardShortcuts;
